export class PriceRuleProductModel {
    public priceRuleProductId: string;
    public productCategoryCode: string;
    public productGroupCode: string;
    public productTypeCode: string;
    public productId: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}